export default __webpack_public_path__ + "3fd4253f70a8c8e5f10380a965129630.png";